<div class="padding">
  <h1 class="left-box">{{ 'hubReportsV2Grid.hubReports' | transloco }}</h1>

  <mat-card>
    <mat-card-content>
      <lib-hub-reports-v2-filter></lib-hub-reports-v2-filter>
      @if (repo.resource$ | async; as data) {
      <div>
        <div class="spacer-small"></div>
        <!-- Main hub reports table -->
        @if (data) {
        <div class="table-container">
          <!-- Conditional paginator at the top (show only when number of hub reports displayed is >= 50) -->
          @if (data.length >= 50) {
          <div>
            <mat-paginator [pageSize]="this.repo.pageSize$ | async" [length]="this.repo.resourceCount$ | async"
              [pageIndex]="this.repo.pageNum$ | async" [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons="true"
              (page)="page($event)"></mat-paginator>
            <div class="spacer-small"></div>
          </div>
          }
          <!-- End of conditional paginator at the top -->
          <!-- Hub reports table -->
          @if (data.length > 0) {
          <table mat-table matSort [dataSource]="data" multiTemplateDataRows class="mat-elevation-z0"
            (matSortChange)="sort($event)">
            <ng-container matColumnDef="reference">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="reference"> {{ 'common.labels.reference' | transloco }} </th>
              <td mat-cell *matCellDef="let hubReport"> {{ hubReport.reference }} </td>
            </ng-container>

            <ng-container matColumnDef="country">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="country"> {{ 'common.labels.country' | transloco }}
              </th>
              <td mat-cell *matCellDef="let hubReport">{{ hubReport.country }}
              <td>
            </ng-container>

            <ng-container matColumnDef="jurisdiction">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="jurisdiction"> {{ 'common.labels.jurisdiction' | transloco }}
              </th>
              <td mat-cell *matCellDef="let hubReport">{{ getJurisdiction(hubReport) }}
              <td>
            </ng-container>

            <ng-container matColumnDef="view">
              <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common.labels.rowActions' | transloco">&nbsp;</th>
              <td mat-cell *matCellDef="let hubReport">
                <button mat-icon-button color="accent" (click)="viewHubReport(hubReport, false)"
                  [attr.aria-label]="'hubReportsV2Grid.viewHubreport' | transloco">
                  <mat-icon>graph_5</mat-icon>
                </button>
                <button mat-icon-button color="accent" (click)="viewHubReport(hubReport, true)"
                  [attr.aria-label]="'hubReportsV2Grid.viewHubreportInNewTab' | transloco">
                  <mat-icon>open_in_new</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let hubReport; columns: columnsToDisplay;" class="expandable-table-row"
              [class.example-expanded-row]="expandedHubReport === hubReport"
              (click)="expandedHubReport = expandedHubReport === hubReport ? null : hubReport" tabindex="0" (keydown.enter)="expandedHubReport = expandedHubReport === hubReport ? null : hubReport">
            </tr>
          </table>
          }
          <!-- End of hub reports table-->
          <!-- Message while loading (show only if data.length is 0 and loading) -->
          @if (((this.repo.loading$ | async) ?? false) && data.length === 0) {
          <div class="padding center padding-top-bottom-50">
            &nbsp;
          </div>
          }
          <!-- Paginator for the bottom -->
          <div class="spacer-small"></div>
          @if (data.length > 0) {
          <mat-paginator [pageSize]="this.repo.pageSize$ | async" [length]="this.repo.resourceCount$ | async"
            [pageIndex]="this.repo.pageNum$ | async" [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons="true"
            (page)="page($event)"></mat-paginator>
          }
          <!-- End of paginator for the bottom -->
        </div>
        }
        <!-- End of main orders table-->
        <!-- Spinner (shows over entire card) -->
        @if (repo.loading$ | async) {
        <div class="loading-spinner-overlay">
          <mat-spinner></mat-spinner>
        </div>
        }
        <!-- End of spinner -->
        <lib-list-issue [repo]="this.repo" [data]="data"></lib-list-issue>
      </div>
      }
      <!-- End of container div for everything -->
    </mat-card-content>
  </mat-card>
</div>